import * as React from "react";
import searchIcon from "../../iconic/magnifying-glass.svg";

interface ITableTextFilterProps {
    onChange: (updatedValue: string) => void;
    searchButtonClick: () => void;
    value: string;
}

function TableTextFilter(p: ITableTextFilterProps) {

    return (
        <div className="input-group mb-1">
            <input type="text" className="form-control" value={p.value} onChange={fieldChange} />
            <div className="input-group-append">
                <button className="btn btn-outline-secondary" type="button" title="Search" onClick={p.searchButtonClick}>
                    <img src={searchIcon} className="button-icon" alt="Search" />
                </button>
            </div>
        </div>
    );

    function fieldChange(event: React.ChangeEvent<HTMLInputElement>) {
        p.onChange(event.target.value);
    }
}

export default TableTextFilter;



// WEBPACK FOOTER //
// ./src/core/TableTextFilter/TableTextFilter.tsx